var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ac-form',{attrs:{"data":_vm.formData,"fetch_url":"","post_url":"https://google.com","params":"","save_submit_route":"","loading_image":""}},[_c('b-button',{attrs:{"type":"submit"}},[_vm._v("Save")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }